
export function toCommas(value) {
    if (value === null || value === undefined) {
        return "";
    }
    if (typeof value === "string") {
        value = parseFloat(value);
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
